import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#student-loan-payoff-app', App);
